var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountBanksCreateAdmin',{attrs:{"AB":_vm.AB,"optionsAccountBankTypes":_vm.optionsAccountBankTypes},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }